/* tslint:disable */
/* eslint-disable */
/**
 * K·HERO
 * K·HERO API documentation
 *
 * OpenAPI spec version: 1.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import { JoinEntityDto } from './join-entity-dto';
 /**
 *
 *
 * @export
 * @interface CreateExerciseWeightDto
 */
export interface CreateExerciseWeightDto {

    /**
     * @type {string}
     * @memberof CreateExerciseWeightDto
     */
    type: CreateExerciseWeightDtoTypeEnum;

    /**
     * @type {number}
     * @memberof CreateExerciseWeightDto
     */
    bias: number;

    /**
     * @type {number}
     * @memberof CreateExerciseWeightDto
     */
    factor: number;

    /**
     * @type {JoinEntityDto}
     * @memberof CreateExerciseWeightDto
     */
    exercise: JoinEntityDto;

    /**
     * @type {JoinEntityDto}
     * @memberof CreateExerciseWeightDto
     */
    client: JoinEntityDto;
}

/**
 * @export
 * @enum {string}
 */
export enum CreateExerciseWeightDtoTypeEnum {
    HEAD = 'HEAD',
    NECK = 'NECK',
    SPINE = 'SPINE',
    LOWERLEFTARM = 'LOWER_LEFT_ARM',
    LOWERRIGHTARM = 'LOWER_RIGHT_ARM',
    UPPERLEFTARM = 'UPPER_LEFT_ARM',
    UPPERRIGHTARM = 'UPPER_RIGHT_ARM',
    LOWERLEFTLEG = 'LOWER_LEFT_LEG',
    LOWERRIGHTLEG = 'LOWER_RIGHT_LEG',
    UPPERLEFTLEG = 'UPPER_LEFT_LEG',
    UPPERRIGHTLEG = 'UPPER_RIGHT_LEG',
    LEFTFOOT = 'LEFT_FOOT',
    RIGHTFOOT = 'RIGHT_FOOT'
}

